import { root_locale } from "../../settings";
import { locale } from "../../translate";
import * as actionTypes from "../actionTypes";

type locale_settings = {
  locale: locale;
} & Partial<actionTypes.settings>;

export const initialState: locale_settings = {
  order_creation_before_interval: undefined,
  order_reschedule_interval: undefined,
  locale: root_locale
};

const reducer = (
  state = initialState,
  action: { type: string; payload: actionTypes.settings }
): typeof initialState => {
  switch (action.type) {
    case actionTypes.SET_SYSTEM_SETTINGS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case actionTypes.CHANGE_LOCALE: {
      return {
        ...state,
        locale: action.payload as unknown as locale
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
